import $ from 'jquery';
import MpDrawer from '../../../../modules/components/drawer.js';
import { applyComponentClickRestrictions, getOptionsFromDataset } from '../../../../util/dom.js';

/** @type {MpDrawer} */
let instance;

const defaultOptions = {
	backdrop: false,
	closable: false,
	disposeOnHide: false,
	skipDataset: true,
	scroll: true,
	navigation: false,
	width: '350px',
	height: 'auto',
	position: 'bottom',
	size: 'comparer',
};

/**
 * @param {HTMLElement} trigger
 * @param {*=} options
 */
export default (trigger, options) => {

	$(trigger).on('click.show-comparer-drawer', (e) => {
		// Standard component click restrictions
		if (applyComponentClickRestrictions('drawer', options, e) === false) {
			return;
		}

		/**
		 * Merge with drawer options
		 *
		 * @type {import('../../../../modules/components/drawer').MpDrawerStaticOptions}
		 */
		const drawerOptions = {
			...getOptionsFromDataset(trigger, 'drawer', true),
			relatedTarget: trigger,
			...options,
		};

		// Toggle the component
		toggleComparerDrawer(drawerOptions);
	});
};

/**
 * @param {import('../../../../modules/components/drawer').MpDrawerStaticOptions} options
 */
export const showComparerDrawer = (options = {}, res = {}) => {

	options = {
		url: mpro.config.routes.compare_preview_drawer,
		...options,
		...defaultOptions,
	};

	if (!instance) {
		if (res.data.count_items > 0) {
			instance = MpDrawer.show(options);
		}
	}
	else {
		if (res.data.count_items > 0) {
			instance.show({ relatedTarget: options.relatedTarget });
		}
	}

	return instance;
};

/**
 * @param {import('../../../../modules/components/drawer').MpDrawerStaticOptions} options
 */
const toggleComparerDrawer = (options = {}) => {

	options = {
		url: mpro.config.routes.compare_preview_drawer,
		...options,
		...defaultOptions,
	};

	if (!instance) {
		instance = MpDrawer.show(options);
	}
	else {
		instance.toggle({ relatedTarget: options.relatedTarget });
	}

	return instance;
};
